import type {ShortcutListQueryVariables} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Shortcut 도메인 Query Key 관리
 *
 * 기존 GraphQL generated types의 getKey 로직을 그대로 재사용
 */
export const SHORTCUT_QUERY_KEY_MAP = {
  /**
   * 바로가기 목록
   * Origin: useShortcutListQuery.getKey
   */
  shortcutList: (variables?: ShortcutListQueryVariables) =>
    variables === undefined
      ? ([ADAPTER_QUERY_KEY_PREFIX, 'shortcutList'] as const)
      : ([ADAPTER_QUERY_KEY_PREFIX, 'shortcutList', variables] as const),
} as const;
